import { TooltipCode } from 'areas/shared/consts';

const BankResolution = { 
    code: "BankResolution", 
    description: "Bank Account Corporate Resolution",
    tooltipCode: TooltipCode.BANKING.BACR
};
const BankingSignatureCard = { 
    code: "BankingSignatureCard", 
    description: "Bank Signature Card(s)",
    tooltipCode: TooltipCode.BANKING.BSC
};
const CancelledChecks = { 
    code: "CancelledChecks",
    description: "10 Cancelled Checks",
    tooltipCode: TooltipCode.BANKING.CC
};

export default {
    BankResolution,
    BankingSignatureCard,
    CancelledChecks
};


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/bankInfo/UploadsConfig.js